import i18next from 'i18next';

i18next.addResources('es_CL', 'Routes', {
  homeTitle: 'KDS - Home',
  homeDescription: 'KDS - Kitchen Home',
  loginTitle: 'KDS - Login'
});

i18next.addResources('es_CR', 'Routes', {
  homeTitle: 'KDS - Home',
  homeDescription: 'KDS - Kitchen Home',
  loginTitle: 'KDS - Login'
});
